function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 0C5.864 0 2.5 3.364 2.5 7.5c0 5.199 6.77 12.029 7.057 12.317a.628.628 0 00.886 0C10.73 19.53 17.5 12.7 17.5 7.5 17.5 3.364 14.136 0 10 0zm2.095 9.961a.624.624 0 01-.805-.366l-.316-.845H9.027l-.317.845a.626.626 0 01-1.17-.439l1.875-5c.183-.487.988-.487 1.171 0l1.389 3.705c.009.019.015.038.021.057l.464 1.238a.625.625 0 01-.365.805z",
  fill: "#0685FE"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 6.155L9.497 7.5h1.008L10 6.155z",
  fill: "#0685FE"
});

function SvgIconPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconPoint;